var _g;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgValueAddedServices = function SvgValueAddedServices(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#373737",
    fillRule: "nonzero",
    d: "M9.545 14.571c.16.292.557.35.794.115l2.17-2.16 2.171 2.16a.502.502 0 0 0 .77-.076l3.787-5.652a.495.495 0 0 0-.14-.689.502.502 0 0 0-.693.138l-3.448 5.147-2.093-2.083a.502.502 0 0 0-.707 0l-2.051 2.04-2.08-3.81a.502.502 0 0 0-.868-.018l-2.65 4.396a.495.495 0 0 0 .172.682.502.502 0 0 0 .686-.171l2.2-3.649 1.98 3.63zM2 6.271C2 5.293 2.79 4.5 3.767 4.5h16.466C21.21 4.5 22 5.294 22 6.27v11.46c0 .976-.79 1.77-1.767 1.77H3.767A1.768 1.768 0 0 1 2 17.73V6.27zm1 0V17.73c0 .43.344.776.767.776h16.466A.772.772 0 0 0 21 17.73V6.27a.772.772 0 0 0-.767-.776H3.767A.772.772 0 0 0 3 6.27z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgValueAddedServices, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/value_added_services.08aaf84a.svg";
export { ForwardRef as ReactComponent };